import axios from 'axios';
import $ from 'jquery';
import cookie from 'react-cookies';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import i18n from './i18n';
import {normalizeLanguage} from './utils';

const session_cookie = cookie.load('auth_headers');
const MySwal = withReactContent(Swal);

const _axios = axios.create({
   withCredentials: true,
   paramsSerializer: $.param,
   headers: {
      Accept: 'application/json',
      'access-token':
         session_cookie !== undefined ? session_cookie['access-token'] : '',
      'token-type':
         session_cookie !== undefined ? session_cookie['token-type'] : '',
      client: session_cookie !== undefined ? session_cookie.client : '',
      expiry: session_cookie !== undefined ? session_cookie.expiry : '',
      uid: session_cookie !== undefined ? session_cookie.uid : '',
   },
});

const BASE = `${process.env.REACT_APP_SERVER_URL}/api/`;
const BUILD = 110;
let updatePopupShown = false;

const requestLocale = () => normalizeLanguage(i18n.resolvedLanguage || i18n.language);

const withLocaleParam = params => ({
   ...(params || {}),
   locale: normalizeLanguage(params?.locale || requestLocale())
});

const connection = {
   getBase() {
      return BASE;
   },

   post(url, params, options) {
      return new Promise((resolve, reject) => {
         _axios
         .post(BASE + url, params, {
            ...options,
            withCredentials: true,
            params: withLocaleParam(options?.params)
         })
         .then(res => {
            updateSession(res);
            this.checkVersion(res);
            resolve(res.data);
         })
         .catch(err => {
            reject(err.response || err);
         });
      });
   },

   get(url, params, options) {
      return new Promise((resolve, reject) => {
         _axios
         .get(BASE + url, {
            ...options,
            withCredentials: true,
            params: withLocaleParam(params)
         })
         .then(res => {
            this.checkVersion(res);
            resolve(res.data);
         })
         .catch(err => {
            reject(err.response || err);
         });
      });
   },

   put(url, params, options) {
      return new Promise((resolve, reject) => {
         _axios
         .put(BASE + url, params, {
            ...options,
            params: withLocaleParam(options?.params)
         })
         .then(res => {
            this.checkVersion(res);
            resolve(res.data);
         })
         .catch(err => {
            reject(err.response || err);
         });
      });
   },

   delete(url, params, options) {
      return new Promise((resolve, reject) => {
         _axios
         .delete(BASE + url, {
            ...(params || {}),
            ...options,
            withCredentials: true,
            params: withLocaleParam(options?.params || params?.params)
         })
         .then(res => {
            this.checkVersion(res);
            resolve(res.data);
         })
         .catch(err => {
            reject(err.response || err);
         });
      });
   },

   checkVersion(res) {
      if (
         !updatePopupShown &&
         res.headers['padelbox-build'] !== undefined &&
         res.headers['padelbox-build'] > BUILD
      ) {
         updatePopupShown = true;
         MySwal.fire({
            titleText: i18n.t('common.app_update_popup.title'),
            text: i18n.t('common.app_update_popup.content'),
            confirmButtonText: i18n.t('common.app_update_popup.confirm'),
         }).then(() => {
            window.location.reload();
         });
      }
   },
};

function updateSession(res) {
   if (typeof res.headers['access-token'] !== 'undefined') {
      let expires = Date.now() + 1000 * 60 * 60 * 24 * 365 * 10;
      expires = new Date(expires);

      cookie.save('auth_headers', {
         'access-token': res.headers['access-token'],
         'token-type': res.headers['token-type'],
         client: res.headers.client,
         expiry: res.headers.expiry,
         uid: res.headers.uid
      }, {
         path: '/',
         expires,
         secure: window.location.protocol === 'https:'
      });

      _axios.defaults.headers['access-token'] = res.headers['access-token'];
      _axios.defaults.headers['token-type'] = res.headers['token-type'];
      _axios.defaults.headers.client = res.headers.client;
      _axios.defaults.headers.expiry = res.headers.expiry;
      _axios.defaults.headers.uid = res.headers.uid;
   }
}

export default connection;
